export const obtenerPorcentajeCalificacion = (calificacion) => {


    let numRespuestas = 0
    let numPuntos = 0

    let respuestas = calificacion.calificaciones


        for (let j = 0; j < respuestas.length;  j++) {
            numRespuestas++
            if (respuestas[j].punto){
                numPuntos++
            }
        }


    //Sacamos promedio

    let prom = (numPuntos * 100) / numRespuestas

    return prom.toFixed(2)


}